import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { notification } from "antd";
import axios from "axios";

import { GlobalContext } from "../../../../../../../app/providers/GlobalState";
import Modulo from "../Modulo/Modulo";

import styles from "./Modulos.module.scss";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class Modulos extends Component {
    static contextType = GlobalContext;
    state = {
        cursoid: 0,
        curso: "",
        retomar: {},
        //modulo_aberto: "0",
        modulos: [],
        botoesVisiveis: false,
        total_conteudos: 0,
        total_conteudos_realizados: 0,
        //PERMISSOES
        loading: false,
        //REDIRECT
        redirect: false,
        redirectLink: "",
        //PRESENÇAS
        totalPresencas: 0,
        totalFolhasPresencas: 0
    };

    //CHAMADA ANTES DO RENDER
    componentWillMount() {
        axios.defaults.timeout = 60 * 10 * 1000;
        var cursoId = this.props.cursoid;

        this.setState({
            cursoid: cursoId
        });

        this.listarModulos(cursoId);
    }

    componentDidUpdate(prevProps) {
        if (this.props.cursoid && this.props.cursoid !== prevProps.cursoid) {
            this.listarModulos(this.props.cursoid);
        }
    }

    //CARREGA E LISTA TODOS OS MODULOS PERTENCENTES AO CURSO E IDENTIFICA A ULTIMA POSIÇÃO NA ORDEM
    listarModulos = disciplinaId => {
        this.setState({
            loading: true
        });

        axios({
            method: "get",
            url: "/api/turma-conteudos/carregar-lista-modulos",
            params: {
                disciplinaId
            }
        })
            .then(response => {
                if (response.data.length === 0) {
                    this.context.atualizarState({
                        lista_modulos: []
                    });

                    this.setState({
                        modulos: [],
                        loading: false
                    });
                }

                if (response.data.length > 0) {
                    this.context.atualizarState({
                        lista_modulos: response.data
                    });

                    this.setState({
                        modulos: response.data,
                        proximaPosicaoModulo: response.data[response.data.length - 1].ordem + 1,
                        loading: false
                    });
                } else
                    this.setState({
                        loading: false
                    });
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    listarModulo = moduloid => {
        axios({
            method: "get",
            url: "/api/curso-modulo/listar-modulo",
            params: {
                cursoid: localStorage.getItem("codigo_curso"),
                moduloid
            }
        })
            .then(response => {
                var moduloIndex = this.state.modulos.findIndex(x => x.id === moduloid);
                var _modulos = this.state.modulos;
                _modulos[moduloIndex] = response.data;

                this.setState({
                    modulos: _modulos
                });
            })
            .catch(() => {});
    };

    concluirAula = (moduloid, aulaid) => {
        axios({
            method: "post",
            url: "/api/player/concluir-aula",
            params: {
                aulaid
            }
        })
            .then(response => {
                this.listarModulo(moduloid);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível concluir o conteúdo!");
            });
    };

    montarBotaoVoltar = () => {
        if (localStorage.getItem("opcao_voltar") != null) {
            const opcaoInfo = JSON.parse(localStorage.getItem("opcao_voltar"));
            return (
                <Link
                    to={opcaoInfo.link_voltar_curso ? opcaoInfo.link_voltar_curso : opcaoInfo.link_voltar}
                    className={`botao-principal ${styles.botaoVoltar}`}
                    onClick={() => opcaoInfo.id_curso && localStorage.setItem("codigo_curso", opcaoInfo.id_curso)}
                >
                    Voltar
                </Link>
            );
        }
    };

    render() {
        const {
            cursoid,
            curso,
            modulo_aberto,
            modulos,
            //REDIRECT
            redirect,
            redirectLink
        } = this.state;

        if (redirect) return <Redirect to={redirectLink} />;

        return (
            <div className={`container container-body ${styles.modulos}`}>
                {this.state.loading ? (
                    <div className="loading-data">
                        <div className="loading" />
                    </div>
                ) : (
                    <div className="curso-modulos">
                        {modulos.map((modulo, index) => (
                            <Modulo
                                key={index}
                                curso={curso}
                                cursoid={cursoid}
                                nomeDisciplina={this.props.nomeDisciplina}
                                index={index}
                                modulo_aberto={modulo_aberto}
                                modulo={modulo}
                                concluirAula={this.concluirAula}
                                disabled={modulo.estado === "BLOQUEADO" || !(modulo.modulo_Aula?.length > 0)}
                            />
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

export default Modulos;
